<template>
  <b-modal
    title="Update Seed"
    ref="update-seed-modal"
    id="update-seed-modal"
    size="lg"
    ok-title="Update"
    @ok="updateSeed"
  >
    <b-card class="m-0" style="font-family: NanumBarunGothic;">
      <validation-observer ref="updateSeedRule" tag="form">
        <b-form-group label-for="subject">
          <div style="display:inline-block; width: 10%;">SUBJECT<span class="text-danger">*</span></div>
          <b-form-input
            id="subject_kor"
            v-model="seed.subjectKor"
            placeholder="주제(한글)"
            disabled
            style="display:inline-block; width:43%; margin-left:1rem;"
          />
          <b-form-input
            id="subject_eng"
            v-model="seed.subjectEng"
            placeholder="주제(영어)"
            disabled
            style="display:inline-block; width:43%; margin-left:1rem;"
          />
        </b-form-group>

        <b-form-group label-for="topic1">
          <div style="display:inline-block; width: 10%;">TOPIC1</div>
            <b-form-input
              id="topic1_kor"
              v-model="seed.topic1Kor"
              style="display:inline-block; width:43%; margin-left:1rem;"
            />
            <b-form-input
              id="topic1_eng"
              v-model="seed.topic1Eng"
              style="display:inline-block; width:43%; margin-left:1rem;"
            />
        </b-form-group>

        <b-form-group label-for="topic2">
          <div style="display:inline-block; width: 10%;">TOPIC2</div>
            <b-form-input
              id="topic2_kor"
              v-model="seed.topic2Kor"
              style="display:inline-block; width:43%; margin-left:1rem;"
            />
            <b-form-input
              id="topic2_eng"
              v-model="seed.topic2Eng"
              style="display:inline-block; width:43%; margin-left:1rem;"
            />
        </b-form-group>

        <b-form-group label-for="category">
          <div style="display:inline-block; width: 10%;">CATEGORY</div>
            <b-form-input
              id="category_kor"
              v-model="seed.categoryKor"
              style="display:inline-block; width:43%; margin-left:1rem;"
            />
            <b-form-input
              id="category_eng"
              v-model="seed.categoryEng"
              style="display:inline-block; width:43%; margin-left:1rem;"
            />
        </b-form-group>

        <b-form-group label-for="brand">
          <div style="display:inline-block; width: 10%;">BRAND</div>
            <b-form-input
              id="brand_kor"
              v-model="seed.brandKor"
              style="display:inline-block; width:43%; margin-left:1rem;"
            />
            <b-form-input
              id="brand_eng"
              v-model="seed.brandEng"
              style="display:inline-block; width:43%; margin-left:1rem;"
            />
        </b-form-group>

        <b-form-group label-for="line">
          <div style="display:inline-block; width: 10%;">LINE</div>
            <b-form-input
              id="line_kor"
              v-model="seed.lineKor"
              style="display:inline-block; width:43%; margin-left:1rem;"
            />
            <b-form-input
              id="line_eng"
              v-model="seed.lineEng"
              style="display:inline-block; width:43%; margin-left:1rem;"
            />
        </b-form-group>

        <b-form-group label-for="product">
          <div style="display:inline-block; width: 10%;">PRODUCT</div>
            <b-form-input
              id="product_kor"
              v-model="seed.productKor"
              style="display:inline-block; width:43%; margin-left:1rem;"
            />
            <b-form-input
              id="product_eng"
              v-model="seed.productEng"
              style="display:inline-block; width:43%; margin-left:1rem;"
            />
        </b-form-group>



      </validation-observer>
    </b-card>
  </b-modal>
</template>

<script>
import { BCard, BFormGroup, BFormInput } from "bootstrap-vue";
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import CISSettingService from '@/services/cis-setting.service'
import CommonService from "@/services/common.service";

export default {
  name: "UpdateSeedModal",
  components: {
    BCard,
    BFormGroup,
    BFormInput,
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    updatingSeed: {
      type: Object,
      default: {},
    },
    refreshData: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      roles: [],

      seed: {},
      required,
    };
  },
  watch: {
    async updatingSeed(newVal) {

      var ctgSq = this.$store.getters.getSelectedCategory
      if(ctgSq == '9999'){
        ctgSq = 1
      }

      const response = await CISSettingService.getSeed({seedSq : newVal.id, ctgSq: ctgSq});
      if (response && response.status === 200) {
        console.log(response.data.data)
        this.seed = response.data.data
      } else {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: response.data.message || "Unknown error",
            icon: "AlertCircleIcon",
            variant: "danger",
          },
        });
      }
    },
  },
  methods: {
    checkInfo() {
      return new Promise((resolve, reject) => {
        this.$refs.updateSeedRule.validate().then((success) => {
          if (success) {
            resolve(true);
          } else {
            reject();
          }
        });
      });
    },
    async updateSeed(e) {
      e.preventDefault();
      await this.checkInfo();

      this.$swal({
        title: "Are you sure?",
        html: `You want to update the Seed!<br>&nbsp;`,
        icon: "warning",
        showCancelButton: true,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
        padding: "1rem",
      }).then(async (result) => {
        if (result.isConfirmed) {
          var ctgSq = this.$store.getters.getSelectedCategory
          if(ctgSq == '9999'){
            ctgSq = 1
          }
          this.seed.ctgSq = ctgSq
          const response = await CISSettingService.updateSeed(this.seed);
          if (response && response.status === 200) {
            this.seed = {};
            this.$bvModal.hide("update-seed-modal");
            this.refreshData();
            this.$toast({
              component: ToastificationContent,
              props: {
                title: `Successfully updated!`,
                icon: "EditIcon",
                variant: "success",
              },
            });
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message || "Unknown error",
                icon: "AlertCircleIcon",
                variant: "danger",
              },
            });
          }
        }
      });
    },
  },
  created() {
  },
};
</script>

<style>

.modal-lg,
.modal-xl {
  max-width: 1100px;
}

</style>